import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useWidth } from "@/utils/resize";
import { useEffect, useState } from "react";
import buriedsdk from "@/utils/zz-buried/index";
import { getCookie } from "cookies-next";

import ad from "@images/features/foot-ad.png";
import inf from "@images/features/foot-inf.png";
import shop from "@images/features/foot-shop.png";
import video from "@images/features/foot-video.png";
import product from "@images/features/foot-product.png";
import right from "@images/features/right.png";

type Props = {
  name: string;
};
const Index = (props: Props) => {
  const { t, i18n } = useTranslation("features");
  const { width, display } = useWidth();

  const list = [
    {
      name: "Find Products",
      title: t("Find Products"),
      desc: t("Products Desc"),
      icon: product,
      href: "/tiktok-products-trends",
    },
    {
      name: "Pick Influencers",
      title: t("Pick Influencers"),
      desc: t("Influencer Desc"),
      icon: inf,
      href: "/tiktok-influencer-marketing",
    },
    {
      name: "Discover Videos",
      title: t("Discover Videos"),
      desc: t("Videos Desc"),
      icon: video,
      href: "/tiktok-videos-analytics",
    },
    {
      name: "Analyze Shops",
      title: t("Analyze Shops"),
      desc: t("Shops Desc"),
      icon: shop,
      href: "/tiktok-shops-analytics",
      mobildHide: true
    },
    // {
    //   name: "TikTok Ads",
    //   title: t("TikTok Ads"),
    //   desc: t("Ads Desc"),
    //   icon: ad,
    //   href: "/tiktok-ads-analytics",
    //   mobildHide: true
    // },
  ];

  return (
    <div className="bg-[#DAF0F8] pt-[66px] pb-[92px]">
      <div className="defeaultContainer">
        <h2 className={styles.title}>
          {t("Choose Shoplus to Boost Your TikTok Performance")}
        </h2>
        <div className={styles.grid}>
          {list.map((item: any) => {
            return props.name !== item.name && (width > 1024 || !item.mobildHide) ? (
              <a
                className={styles.items}
                key={item.name}
                href={item.href}
                onClick={() => {
                  buriedsdk.buried({
                    event: `按钮点击`,
                    scene: `${props.name}落地页-关联模块${item.name}`,
                    URL: process.env.publicApiDomain,
                  });
                }}
              >
                <Image
                  width={width > 1024 ? 85 : 58}
                  height={width > 1024 ? 85 : 58}
                  src={item.icon}
                  alt="Pick Influencer"
                ></Image>
                <div className="w-full flex-1">
                  <h3 className={styles.title}>{item.title}</h3>
                  <p className={styles.desc}>{item.desc}</p>
                </div>
                <div className="flex justify-end w-full lg1024:justify-center">
                  <Image width={24} height={24} src={right} alt=""></Image>
                </div>
              </a>
            ) : null;
          })}
        </div>
      </div>
    </div>
  );
};

export default Index;
